import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Injectable } from "@angular/core";

import { routesConstants } from '@app/shared/models/LinksView';
import { default as constantsFile } from '@app/shared/constants.json';
import { Logger } from '@app/core';

const log = new Logger('AirlineGuard');

@Injectable()
export class AirlineGuard implements CanActivate
{
	constants: any = constantsFile.constants;

    constructor(
        private router: Router,
        private authenticationService: AuthenticationService
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		if (!this.authenticationService.isAuthenticated())
      	{
        	log.debug('Not authenticated, redirecting...');
        	this.router.navigate([routesConstants.landing], { queryParams: { returnUrl: state.url != '/' ? state.url : routesConstants.charts }});
        	return false;
      	}
      	// This guard has been created for the rest of roles (not Premium or Admin)
      	const user = this.authenticationService.credentials;
      	if(!user?.roleName.includes(this.constants.roleNames.airline) && !user?.roleName.includes(this.constants.roleNames.airlineplus) && !user?.roleName.includes(this.constants.roleNames.agency)) {
          if(user?.roleName.includes(this.constants.roleNames.premium))
          {
            log.debug('Premium user, redirecting to analytics...');
            this.router.navigate([routesConstants.analytics]);
          }
          else if (user?.roleName.includes(this.constants.roleNames.admin))
          {
              log.debug('Admin user, redirecting to support...');
              this.router.navigate([routesConstants.communications.communications]);
          }
        	return false;
      	} else {
	        if (state.url === '/') {
            const url = user.roleName.includes(this.constants.roleNames.premium)
            		? routesConstants.analytics
            		: routesConstants.charts;

				    log.debug('Redirecting to ' + url + '...');
            this.router.navigate([url]);
        	}
        	log.debug('Allowed to ' + state.url);
        	return true;
      	}
    }

}
